module.exports = __webpack_public_path__ + "img/20220328_144216.2f5836cb.jpg";